import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import Switch from 'react-switch';
import { useDispatch, useSelector } from 'react-redux';
import { selectAdminToken } from '../../sessionSlice'; // adjust import
import { fetchThemeData, selectTheme } from '../../themeSlice';
import './quizSettings.css';
import { updateThemeData } from '../../functions/updateThemeData';

export default function QuizSettings({ isOpen, onClose }) {
  const dispatch = useDispatch();
  const adminToken = useSelector(selectAdminToken);
  const { availableThemes, currentTheme, status, data } = useSelector((state) => state.theme);

  // local state
  const [correctPoints, setCorrectPoints] = useState(1);
  const [wrongPoints, setWrongPoints] = useState(0);
  const [eachTime, setEachTime] = useState(60);
  const [noOfQuestion, setNoOfQuestion] = useState(10);
  const [shuffle, setShuffle] = useState(false);
  const [lifelines, setLifelines] = useState(false);
  const [expert, setExpert] = useState(false);
  const [doubleDip, setDoubleDip] = useState(false);
  const [flip, setFlip] = useState(false);
  const [fiftyFifty, setFiftyFifty] = useState(false);

  // load existing on open
  useEffect(() => {
    if (!isOpen || !data) return;

    setCorrectPoints(data.correctPoints ?? 1);
    setWrongPoints(data.wrongPoints ?? 0);
    setEachTime(data.eachTime ?? 60);
    setNoOfQuestion(data.noOfQuestion ?? 10);
    setShuffle(data.shuffle ?? false);
    setLifelines(data.lifelines ?? false);
    setExpert(data.expert ?? false);
    setDoubleDip(data.double ?? false);
    setFlip(data.flip ?? false);
    setFiftyFifty(data.fifty_fifty ?? false);
  }, [isOpen, data, currentTheme]);

  useEffect(() => {
    dispatch(fetchThemeData({ themeId: currentTheme }));
  }, [dispatch]);

  const handleSubmit = async () => {
  const payload = {
    data: {
      correctPoints,
      wrongPoints,
      eachTime,
      noOfQuestion,
      shuffle,
      lifelines,
      expert,
      double: doubleDip,
      flip,
      fifty_fifty: fiftyFifty
    },
    currentTheme
  };

  try {
    // use the shared helper
    await updateThemeData({ payload, token: adminToken });
    Swal.fire("Success", "Settings saved!", "success");
    window.location.reload();
    onClose();
  } catch (e) {
    Swal.fire("Error", e.message || "Failed to save settings", "error");
  }
};


  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop" onClick={onClose} />
      <div className="quiz-settings-modal">
        <h2>Quiz Settings</h2>

        {/* two rows of inputs */}
        <div className="setting-row">
          <div className="setting-input">
            <label>Correct Answer Points</label>
            <input
              type="number"
              min="0"
              value={correctPoints}
              onChange={e => setCorrectPoints(parseInt(e.target.value))}
            />
            <div className="code">* user will get these points for each correct answer</div>
          </div>
          <div className="setting-input">
            <label>Incorrect Answer Points</label>
            <input
              type="number"
              min="0"
              value={wrongPoints}
              onChange={e => setWrongPoints(parseInt(e.target.value))}
            />
            <div className="code">* Use the up and down arrows to select the incorrect point.</div>
          </div>
        </div>
        <div className="setting-row">
          <div className="setting-input">
            <label>Timer for each question (in seconds)</label>
            <input
              type="number"
              min="0"
              value={eachTime}
              onChange={e => setEachTime(parseInt(e.target.value))}
            />
            <div className="code">* user will have these much time for each question</div>
          </div>
          <div className="setting-input">
            <label>No of questions to dispay</label>
            <input
              type="number"
              min="1"
              value={noOfQuestion}
              onChange={e => setNoOfQuestion(parseInt(e.target.value) || 1)}
            />
              <div className="code">* flip lifelines needs one additional question to quiz to work.</div>
          </div>
        </div>

        {/* single toggles */}
        <div className="setting-toggle-single">
          <label>Shuffle Questions</label>
          <Switch checked={shuffle} onChange={setShuffle} />
        </div>
        <div className="setting-toggle-single">
          <label>Lifelines</label>
          <Switch checked={lifelines} onChange={setLifelines} />
        </div>
        <hr/>

        {/* conditional lifeline toggles */}
        {lifelines && (
          <>
            <div className="setting-row lifelines-toggle">
              <div className="setting-input-toggle">
                <label>Expert Advise</label>
                <input
                  type="checkbox"
                  checked={expert}
                  onChange={e => setExpert(e.target.checked)}
                />
              </div>
              <div className="setting-input-toggle">
                <label>Double Dip</label>
                <input
                  type="checkbox"
                  checked={doubleDip}
                  onChange={e => setDoubleDip(e.target.checked)}
                />
              </div>
                            <div className="setting-input-toggle">
                <label>Flip 1 Question</label>
                <input
                  type="checkbox"
                  checked={flip}
                  onChange={e => setFlip(e.target.checked)}
                />
              </div>
              <div className="setting-input-toggle">
                <label>50:50</label>
                <input
                  type="checkbox"
                  checked={fiftyFifty}
                  onChange={e => setFiftyFifty(e.target.checked)}
                />
              </div>
            </div>
            <div className="setting-row lifelines-toggle">

            </div>
          </>
        )}

        <div className="actions">
          <button className="cancel-btn" onClick={onClose}>Cancel</button>
          <button className="save-btn" onClick={handleSubmit}>Save</button>
        </div>
      </div>
    
     
    </>
  );
}
